window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      const tabsContainerClassQuery = '.cpap__simple-tab-menu__tabs-container';
      const paginationButtonClassName = 'cpap__simple-tab-menu__pagination-button';
      const getNodeWidth = (parentNode, nodeQuery) =>
        parentNode.querySelector(nodeQuery).getBoundingClientRect().width;

      const resizeTabbedNavigationMenu = (node) => {
        const tabsContainerWidth = getNodeWidth(node, tabsContainerClassQuery);
        const tabsWidth = getNodeWidth(node, '.cpap__simple-tab-menu__tabs');
        const activeClass = 'cpap__simple-tab-menu__pagination-container--active';
        const classListAction = tabsWidth > tabsContainerWidth ? 'add' : 'remove';

        node
          .querySelector('.cpap__simple-tab-menu__pagination-container')
          .classList[classListAction](activeClass);
      };

      document.querySelectorAll('.cpap__simple-tab-menu')?.forEach((tabMenuNode) => {
        resizeTabbedNavigationMenu(tabMenuNode);

        // Don't add the resize listener for actual mobile devices to save resources
        if (!window.cpap.isMobileDevice()) {
          const debouncedResizeTabbedNavigationMenu = window.cpap.debounce(
            () => resizeTabbedNavigationMenu(tabMenuNode),
            600
          );

          window.addEventListener('resize', debouncedResizeTabbedNavigationMenu, { passive: true });
        }

        tabMenuNode.querySelectorAll(`.${paginationButtonClassName}`).forEach((node) => {
          node.addEventListener('click', () => {
            const tabsContainerNode = tabMenuNode.querySelector(tabsContainerClassQuery);
            const currentScrollLeftPosition = tabsContainerNode.scrollLeft;
            const directionMultiplier = node.classList.contains(
              `${paginationButtonClassName}--next`
            )
              ? 1
              : -1;

            tabsContainerNode.scrollTo({
              left: currentScrollLeftPosition + 300 * directionMultiplier,
              behavior: 'smooth',
            });
          });
        });
      });
    },
    { priority: 'user-blocking' }
  );
});
